module.exports = __webpack_public_path__ + "static/media/page4.8bb3432b.svg";